import { memo, useState } from "react";
import cx from "../../../lib/cx";
import IconButton from "../IconButton/IconButton.jsx";
import styles from "./banner.css";

/**
 * A functional component that renders a dismissible banner with a title and message.
 *
 * @param {Object} props The properties passed to the component.
 * @param {string} props.title The title text displayed in the banner.
 * @param {string} props.message The message text displayed in the banner.
 * @param {JSX.Element|null} props.actionButton An action button passed to the banner.
 * @return {JSX.Element|null} The rendered banner component if open, or null if dismissed.
 */
function Banner({ title, message, closeButton = true, actionButton = null }) {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;

  return (
    <div className={styles.wrapper}>
      <div className={cx(styles.container, styles.appear)}>
        {title && <h2 className={styles.title}>{title}</h2>}

        {message && <p className={styles.message}>{message}</p>}
      </div>

      {actionButton && actionButton}

      {closeButton && (
        <IconButton
          name="close"
          value="schliessen"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

export default memo(Banner);
